import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled from 'styled-components';
import T from 'prop-types';
import { black, black8, black2, purple } from '../../styles/colors';
import { body2 } from '../../styles/typography';
import { Icon } from '../Icon/Icon';
import { NavigationActionGlyph } from '../NavigationActionGlyph/NavigationActionGlyph';
import { NavigationLabel } from '../NavigationLabel/NavigationLabel';
import { NavigationButton } from '../NavigationButton/NavigationButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledNavigationButton = /*#__PURE__*/styled(NavigationButton).withConfig({
  displayName: "StyledNavigationButton",
  componentId: "sc-1whn6pq-0"
})(["", " height:100%;border-bottom:1px solid transparent;:hover{background-color:", ";}:active,&.focus-visible{background-color:", ";}&[aria-current='page']{border-bottom-color:", ";}"], body2, black2, black8, purple);

const NavigationItem = (_ref) => {
  let {
    children,
    selected,
    glyph,
    action
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "selected", "glyph", "action"]);

  return /*#__PURE__*/_jsx(StyledNavigationButton, Object.assign({}, restProps, {
    selected: selected,
    "aria-current": selected ? 'page' : undefined,
    children: /*#__PURE__*/_jsxs(NavigationLabel, {
      children: [glyph && /*#__PURE__*/_jsx(Icon, {
        glyph: glyph,
        size: "xsmall",
        primaryColor: selected ? purple : black
      }), children, action && /*#__PURE__*/_jsx(NavigationActionGlyph, {
        action: action,
        size: "xsmall"
      })]
    })
  }));
};

NavigationItem.propTypes = {
  children: T.node,
  disabled: T.bool,
  selected: T.bool,
  glyph: T.elementType,
  action: T.oneOf(['dropdown', 'follow']),
  dividers: T.arrayOf(T.oneOf(['left', 'right']))
};
export { NavigationItem };